import { render } from "./Philosophy.vue?vue&type=template&id=6e909d0d"
import script from "./Philosophy.vue?vue&type=script&lang=js"
export * from "./Philosophy.vue?vue&type=script&lang=js"

import exportComponent from "/Users/admin/Work/CIS_HOME/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__